<template>
  <div class="message">
    <div class="content">
      <div class="card">
        <div class="menu">
          <div class="tabs">
            <div class="title" :class="{active:page === 'evaluate'}" @click="changeTitle('evaluate')">订单评价</div>
            <div class="title" :class="{active:page === 'complaint'}" @click="changeTitle('complaint')">订单投诉</div>
          </div>
          <div class="search-bar" v-if="page === 'evaluate'">
            <Input v-model="evaluateKeywords" placeholder="请输入订单号/关键字" clearable @on-enter="searchEvaluate" />
            <Button type="primary" @click="searchEvaluate">搜索</Button>
          </div>
          <div class="search-bar" v-if="page === 'complaint'">
            <Input v-model="complaintKeywords" placeholder="请输入订单号/关键字" clearable @on-enter="searchComplaint" />
            <Button type="primary" @click="searchComplaint">搜索</Button>
          </div>
        </div>
        <div class="evaluate" v-if="page === 'evaluate'">
          <div class="" v-loading="evaluateLoading">
            <EvaluateItem :item='item' v-for="(item,i) in evaluate" :key="item.id || i">
            </EvaluateItem>
            <el-empty :image-size="120" v-if="evaluate.length==0"></el-empty>
            <PageComponents :total="tableShow.listCount" :current="tableShow.currentPage" :pageSize="tableShow.pageSize"
              @on-change="changePage" v-if="evaluate.length>0"></PageComponents>
          </div>
        </div>
        <div class="complaint" v-if="page === 'complaint'">
          <div class="" v-loading="complaintLoading">
            <ComplaintItem :item='item' v-if="complaint.length>0" v-for="(item,i) in complaint" :key="item.id || i"></ComplaintItem>
            <el-empty :image-size="120" v-if="complaint.length==0"></el-empty>
            <PageComponents :total="tableComShow.listCount" :current="tableComShow.currentPage"
              :pageSize="tableComShow.pageSize" @on-change="changePage" v-if="complaint.length>0"></PageComponents>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import HeaderComponents from '../../components/header'
  import PageComponents from '../../components/page'
  import EvaluateItem from './components/evaluate-item'
  import ComplaintItem from './components/complaint-item'

  export default {
    name: 'setting',
    components: {
      ComplaintItem,
      EvaluateItem,
      HeaderComponents,
      PageComponents
    },
    created() {
      let vm = this
      vm.getEvaluate()
    },
    data() {
      return {
        tableShow: {
          currentPage: 1,
          pageSize: 10,
          listCount: 0
        },
        evaluateLoading: false,
        complaintLoading: false,
        evaluateLoaded: false,
        complaintLoaded: false,
        tableComShow: {
          currentPage: 1,
          pageSize: 10,
          listCount: 0
        },
        user: {
          head_img: "",
          nickname: "",
        },
        evaluateKeywords: '',
        complaintKeywords: '',
        evaluate: [],
        complaint: [],
        page: 'evaluate'
      }
    },
    methods: {
      getComplaint() {
        let vm = this
        vm.complaintLoading = true
        this.$request('615543c347534', {
          page: vm.tableComShow.currentPage,
          size: vm.tableComShow.pageSize,
          from: 2,//1:小程序、2:PC
          keywords: vm.complaintKeywords,
        }).then(res => {
          vm.tableComShow.listCount = res.data.count
          vm.complaint = []
          res.data.data.forEach(function(it) {
            vm.complaint.push(it)
          })
          vm.complaintLoaded = true
        }).finally(() => {
          vm.complaintLoading = false
        })
      },
      getEvaluate() {
        let vm = this
        vm.evaluateLoading = true
        this.$request('615136dd3ff39', {
          page: vm.tableShow.currentPage,
          size: vm.tableShow.pageSize,
          keywords: vm.evaluateKeywords,
        }).then(res => {
          vm.tableShow.listCount = res.data.data.count
          vm.evaluate = []
          res.data.data.list.forEach(function(it) {
            vm.evaluate.push({
              "id": it.id,
              "user_name": it.nickname,
              "head_img": it.head_img,
              "title": it.title,
              "address": it.address || '',
              "order_id": it.order_id,
              "number": it.number,
              "evaluate": it.evaluate,
              "worker_star": it.worker_star,
              "order_star": it.order_star,
              "created_at": it.created_at,
              "img": it.img,
            })
          })
          vm.evaluateLoaded = true
        }).finally(() => {
          vm.evaluateLoading = false
        })
      },
      changePage(page) {
        if (this.page == "evaluate") {
          this.tableShow.currentPage = page
          this.getEvaluate()
        } else {
          this.tableComShow.currentPage = page
          this.getComplaint()
        }
      },
      changeTitle(title) {
        this.page = title
        if (title == "evaluate" && !this.evaluateLoaded) {
          this.tableShow.currentPage = 1
          this.getEvaluate()
        } else if (title == "complaint" && !this.complaintLoaded) {
          this.tableComShow.currentPage = 1
          this.getComplaint()
        }
      },
      searchComplaint() {
        this.tableComShow.currentPage = 1
        this.getComplaint()
      },
      searchEvaluate() {
        this.tableShow.currentPage = 1
        this.getEvaluate()
      },
      clickDetail() {
        this.$router.push({
          name: 'message_detail',
          params: {
            id: 0
          }
        })
      }
    }
  }
</script>

<style lang="less">
  .message {
    .ivu-steps-title {
      margin-top: 2px;
    }

    .content {
      background-color: #f7f8fa;
    }

    .card {
      background-color: #FFFFFF;
      padding: 20px;
      border-radius: 3px;

      .menu {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        .tabs {
          display: flex;
          align-items: center;
          flex: 1;
        }

        .search-bar {
          margin-bottom: 0;
        }

        .title {
          font-size: 18px;
          color: #333;
          position: relative;
          margin-right: 30px;
          cursor: pointer;


        }

        .active {
          font-weight: 450;

          &::after {
            content: '';
            position: absolute;
            bottom: -10px;
            left: 0;
            width: 70px;
            height: 3px;
            background-color: #FB9E2F;
          }
        }
      }

      .evaluate,
      .complaint {
        margin-top: 30px;
      }

      .search-bar {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-bottom: 20px;

        .ivu-input-wrapper {
          width: 260px;
          margin-right: 10px;
        }

        .ivu-input,
        .ivu-btn {
          height: 32px;
          line-height: 32px;
        }

        .ivu-input-icon-clear {
          height: 32px;
          line-height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
</style>
